<template>
  <div>
    <div class="green lighten-4">
      <v-container style="max-width: 1800px" id="asdasdasdasd">
        <v-btn
          class="mr-2 white"
          link
          to="area"
          active-class="white--text primary"
          outlined
          elevation="0"
        >{{ $t('market.setting_stall') }}</v-btn>
        <v-btn
          class="mr-2 white"
          link
          to="bill"
          active-class="white--text primary"
          outlined
          elevation="0"
        >{{ $t('market.setting_document') }}</v-btn>
         <v-btn
          class="mr-2 white"
          link
          to="penalty"
          active-class="white--text primary"
          outlined
          elevation="0"
        >{{ $t('market.setting_penalty') }}</v-btn>
        <v-btn
          class="mr-2 white"
          active-class="white--text primary"
          link
          to="water"
          outlined
          elevation="0"
        >{{ $t('market.setting_meter_water') }}</v-btn>
        <v-btn
          class="mr-2 white"
          link
          to="elec"
          active-class="white--text primary"
          outlined
          elevation="0"
        >{{ $t('market.setting_meter_elec') }}</v-btn>
        <v-btn
          class="mr-2 white"
          link
          to="billing"
          active-class="white--text primary"
          outlined
          elevation="0"
        >{{ $t('market.setting_billing') }}</v-btn>
        <v-btn
          class="mr-2 white"
          link
          to="areaaccountingproduct"
          active-class="white--text primary"
          outlined
          elevation="0"
        >{{ $t('market.setting_billing_price') }}</v-btn>
      </v-container>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      countSettingTasks: "settingTask/countSettingTasks"
    })
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>

</style>